import { Injectable} from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { AutorizationService} from './api/autorization.service';
import {  Token} from './models/api_models/token';
import {  Observable, observable} from 'rxjs';
import { UserApi,  BilanEco,  UserBilan} from './models/api_models/user';
import {  BasicResponse } from './models/api_models/basicResponse';
import { retry } from 'rxjs/operators';
import {  error } from '@angular/compiler/src/util';
import {  CookieService} from 'ngx-cookie-service';


@Injectable({
  providedIn: 'root'
})
export class UserApiService {

  public apiUrl = "https://api1.clem.mobi";


// requete cgu 
getCGU(url): Observable<any> {
  let tokenString = localStorage.getItem('token_offline')
 let token =  JSON.parse(tokenString)  

        let httpOptions = {
          headers: new HttpHeaders()
            .set('Authorization', 'Bearer ' +token.access_token)}
            
  return this.http.get<any>( `${this.apiUrl}${url}` ,httpOptions);
}

// requete cgu authentificate
getCGUisAthentificate(): Observable<any> {

 let tokenString = localStorage.getItem('token_clem_mobi')
 let token =  JSON.parse(tokenString)  

        let httpOptions = {
          headers: new HttpHeaders()
            .set('Authorization', 'Bearer ' +token.access_token)}
            
  return this.http.get<any>('https://api1.clem.mobi/api/v2/user_details/0',httpOptions);
}

// get  facture
public getFactureUser(startdate :Date, enddate: Date) : Observable<any> {

    
  let tokenString = localStorage.getItem('token_clem_mobi')
  let token =  JSON.parse(tokenString)  

      let httpOptions = {
        headers: new HttpHeaders()
          .set('Authorization', 'Bearer ' +token.access_token)}

  return this.http.get<any>(`https://api1.clem.mobi/api/v2/users/0/wallet?startdate=${startdate.toISOString()}&enddate=${enddate.toISOString()}`, httpOptions)
    
}

// get  facture
public getPaiement() : Observable<any> {

    
  let tokenString = localStorage.getItem('token_clem_mobi')
  let token =  JSON.parse(tokenString)  

      let httpOptions = {
        headers: new HttpHeaders()
          .set('Authorization', 'Bearer ' +token.access_token)
          .set('accept', 'application/json')}

  return this.http.get<any>(this.apiUrl + "/api/v2/users/0/payment", httpOptions)
    
}




// get  facture
public getUserDetailPaiement() : Observable<any> {

    
  let tokenString = localStorage.getItem('token_clem_mobi')
  let token =  JSON.parse(tokenString)  

      let httpOptions = {
        headers: new HttpHeaders()
          .set('Authorization', 'Bearer ' +token.access_token)
          .set('Accept', '3')}

  return this.http.get<any>(this.apiUrl + "/api/v2/user_details/0", httpOptions)
    
}


// patch  user
public patchUserDetail(body) : Observable<any> {



  let tokenString = localStorage.getItem('token_clem_mobi')
  let token =  JSON.parse(tokenString)  

      let httpOptions = {
        headers: new HttpHeaders()
          .set('Authorization', 'Bearer ' +token.access_token)
          // .set('accept', 'application/json')
        }

  return this.http.patch<any>(this.apiUrl + "/api/v2/user_details/0", JSON.stringify(body), httpOptions)
    
}

// patch  user
public unsubscribeUser(body) : Observable<any> {


  let tokenString = localStorage.getItem('token_clem_mobi')
  let token =  JSON.parse(tokenString)  

      let httpOptions = {
        headers: new HttpHeaders()
          .set('Authorization', 'Bearer ' +token.access_token)
          // .set('accept', 'application/json')
        }

  return this.http.patch<any>(this.apiUrl + "/api/v2/user_details/0", JSON.stringify(body), httpOptions)
    
}



postCodePromo(){

  let tokenString = localStorage.getItem('token_clem_mobi')
  let token =  JSON.parse(tokenString)  

      let httpOptions = {
        headers: new HttpHeaders()
          .set('Authorization', 'Bearer ' +token.access_token)
          // .set('accept', 'application/json')
        }
  return this.http.post<any>(this.apiUrl + "/api/v2/users/0/code_promo", '' ,httpOptions)
      
}


getCodePromo(){

  let tokenString = localStorage.getItem('token_clem_mobi')
  let token =  JSON.parse(tokenString)  

      let httpOptions = {
        headers: new HttpHeaders()
          .set('Authorization', 'Bearer ' +token.access_token)
          // .set('accept', 'application/json')
        }
  return this.http.get<any>(this.apiUrl + "/api/v2/users/0/code_promo", httpOptions)
      
}



// patch  user
public deleteUser(id) : Observable<any> {


  let tokenString = localStorage.getItem('token_clem_mobi')
  let token =  JSON.parse(tokenString)  

      let httpOptions = {
        headers: new HttpHeaders()
          .set('Authorization', 'Bearer ' +token.access_token)
          // .set('accept', 'application/json')
        }

  return this.http.delete<any>('https://oauth2.clem.mobi/api/users/'+id, httpOptions)
    
}


 
   // get user bilan carbon
  public getUserBilanEco(userId: number, startDate: Date, endDate: Date) {
    return new Observable<BilanEco>((observer) => {
      this.oauthService.login(null).subscribe(response => {
        let token = <Token>response;
        let httpOptions = {
          headers: new HttpHeaders()
            .set('Authorization', 'Bearer ' + token.access_token)
        };
        this.http.get(this.apiUrl + "/api/v2/users/" + userId + "/bilan?startdate=" + startDate.toISOString() + "&enddate=" + endDate.toISOString(), httpOptions).subscribe(
          response => {
            let bilan = <BilanEco>(<BasicResponse>response).data;
            observer.next(bilan);
            observer.complete();
          },
          error => {
            observer.next(undefined);
            observer.complete();
          }
        );
      },
        error => {
          observer.next(undefined);
          observer.complete();
        },
      )
    });
  }


  public getCurrentUserWallet(start: Date, end: Date) {
    return new Observable<any>((observer) => {
      this.oauthService.login(null).subscribe(response => {
        let token = <Token>response;
        let httpOptions = {
          headers: new HttpHeaders()
            .set('Authorization', 'Bearer ' + token.access_token)
        };
        this.http.get(this.apiUrl + "/api/v2/users/0/wallet?startdate=" + start.toISOString() + "&enddate=" + end.toISOString(), httpOptions).subscribe()
      })
    });
  }

  public updateUser(user: UserApi) {
    return new Observable<any>((observer) => {
      this.oauthService.login(null).subscribe(
        response => {
          
          let token = <Token>response;
          let header = {
            headers: new HttpHeaders()
              .set('Authorization', 'Bearer ' + token.access_token)
              .set('Content-Type', 'application/x-www-form-urlencoded')
          }

          this.http.put(this.apiUrl + "/api/v2/users/0", "rfid=" + encodeURIComponent(user.rfid) + "&phonenumber=" + encodeURIComponent(user.phonenumber), header).subscribe(response => {
            observer.next(response);
            observer.complete();
          }, error => {
            observer.error(error);
            observer.complete();
          });
        },
        error => {
          observer.error(error);
          observer.complete();
        }
      );

    })
  }


  public updatePassword(currentPassword: string, newPassword: string, user:any) {
    return new Observable<any>((observer) => {
      this.oauthService.login(null).subscribe(
        response => {

          let token = <Token>response;
          let header = {
            headers: new HttpHeaders()
              .set('Authorization', 'Bearer ' + token.access_token)
              .set('Content-Type', 'application/x-www-form-urlencoded')
          }
          console.log()
          let body = {
            email: user.email,
            username: user.name,
            new_password: newPassword,
            password: currentPassword
          }
          console.log(body)

          const payload = new HttpParams()
          .set('username', user.name,)
          .set('email', user.email)
          .set('new_password', newPassword)
          .set('password', currentPassword)

          this.http.post("https://oauth2.clem.mobi/oauth/v1/authorize/update-password",payload, header).subscribe(response => {
            observer.next(response);
            observer.complete();
          }, error => {
            observer.error(error);
            observer.complete();
          });
        },
        error => {
          observer.error(error);
          observer.complete();
        }
      );

    })
  }

  //reset password 
  public resetPassword(password: string, resetToken: string) {
   
    return new Observable<any>((observer) => {

      this.oauthService.login(null).subscribe(
        response => {

          let token = <Token>response;
          let header = {
            headers: new HttpHeaders()
              .set('Authorization', 'Bearer ' + token.access_token)
              .set('Content-Type', 'application/x-www-form-urlencoded')
          }

          const body = new HttpParams()
          .set('password', password)
          .set('resetToken', resetToken)
        

          this.http.post<any>("https://oauth2.clem.mobi/oauth/v1/authorize/reset-password", body, header).subscribe(
              response => {
                observer.next(response);
                observer.complete();
              }, error => {
                observer.error(error);
                observer.complete();
              }
            )
        },
        error => {

          observer.error(error);
          observer.complete();
        })
    })

  }

  //password lost
  public LostPassword(login: string, redirectUrl: string) {
    return new Observable<any>((observer) => {

      this.oauthService.login(null).subscribe(
        response => {

          let token = <Token>response;
          let httpOptions = {
            headers: new HttpHeaders()
              .set('Authorization', 'Bearer ' + token.access_token)
              .set('Content-Type', 'application/x-www-form-urlencoded')
          };

          // let data = {email: email, username: login, redirect_url: redirectUrl }

          const body = new HttpParams()
          .set('username', login)
          .set('redirect_url', redirectUrl)
        

          this.http.post<any>("https://oauth2.clem.mobi/oauth/v1/authorize/forgot-password", body, httpOptions).subscribe(
              response => {
                observer.next(error);
                observer.complete();
              }, error => {
                observer.error(error);
                observer.complete();
              }
            )
        },
        error => {
          observer.error(error);
          observer.complete();
        })
    })
  }


  //get validate RGPD 
  public isRGPDOK(): boolean {
    if (this.cookieService.get("user_validation")) {
      return true;
    }
    return false;
  }


  //cookie  post
  public validateRGPD(): void {
    let expiredDate = new Date();
    expiredDate.setDate(expiredDate.getDate() + 350);
    this.cookieService.set("user_validation", "true", expiredDate);
  }


  //get user data with communities
  public getCurrentUserData() {
    return new Observable<UserApi>((observer) => {
      this.oauthService.login(null).subscribe(response => {
        let token = <Token>response;
        let httpOptions = {
          headers: new HttpHeaders()
            .set('Authorization', 'Bearer ' + token.access_token)
            .set('Content-Type', 'application/x-www-form-urlencoded')
        };
        if (token.grant_type == "client") {
          observer.error(null);
          observer.complete();
        } else {
          this.http.get(this.apiUrl + "/api/v2/users/3?withCommunities=yes", httpOptions)
            .subscribe(
              response => {
                let user = UserApi.copyFromApi(<UserApi>(<BasicResponse>response).data);
                console.log(user)
                observer.next(user);
                observer.complete();
              },
              error => {
                observer.error(undefined);
                observer.complete();
              }
            );
        }
      },
        error => {
          observer.next(undefined);
          observer.complete();
        },
      )
    });
  }

  //get me details
  public getUserDetail() {
    return new Observable<UserBilan>((observer) => {
      this.oauthService.login(null).subscribe(response => {
        let token = <Token>response;
        let httpOptions = {
          headers: new HttpHeaders()
            .set('Authorization', 'Bearer ' + token.access_token)
            .set('Accept', '3')
        };

        if (token.grant_type == "client") {
          observer.error(null);
          observer.complete();
        } else {
          this.http.get(this.apiUrl + "/api/v2/user_details/0", httpOptions)
            .pipe(retry(3))
            .subscribe(
              response => {
                observer.next(<UserBilan>(<BasicResponse>response).data);
                observer.complete();
              },
              error => {
                observer.error(null);
                observer.complete();
              })
        }
      },
        error => {
          observer.next(undefined);
          observer.complete();
        },
      )
    })

  }


  constructor(private http: HttpClient, private oauthService: AutorizationService, private cookieService: CookieService) { }
}
